import {
  TOGGLE_PLACES_MODAL,
  OPEN_PLACES_MODAL,
  CLOSE_PLACES_MODAL,
  CHANGE_SLIDE,
} from './types';

import { setLimtAndPage } from './selectedPlaceActions';
import { getPlaceThemes } from './placeActions';

import { limitForDay } from '../../constants/limits';

export const togglePlacesModal = () => {
  return (dispatch, getState) => {
    const isModalOpen = getState().placesModal.isModalOpen;
    dispatch(toggleModal(!isModalOpen));
  };
};

export const toggleModal = modalState => {
  return {
    type: TOGGLE_PLACES_MODAL,
    modalIsOpen: modalState,
  };
};

export const openThemesModalAndSetSlideIndex = ({ slideIndex, themeType }) => {
  return {
    type: OPEN_PLACES_MODAL,
    slideIndex,
    themeType,
  };
};

export const closeSliderModal = () => ({ type: CLOSE_PLACES_MODAL });

export const changeSlide = ({ slideTo, slideIndex }) => {
  return async (dispatch, getState) => {
    const {
      placesModal,
      servicesModal,
      selectedPlace,
      schema: { places },
    } = getState();
    const { themeType } = placesModal;
    const { id: placeId } = selectedPlace;
    const themeConfig = selectedPlace[themeType];
    const { limit, page, categories, isLastPage } = themeConfig;
    const themeIdsArrayLength = places.byId[placeId][themeType].length;
    const openPlacesModalFrom = servicesModal.openPlacesModalFrom;
    if (slideTo === 0 && !isLastPage && slideIndex !== 1) {
      /** since in trek day, the slider uses different limit to make sure it works smoothly,
      change slide should also be calling th same limit while in day so that they do not call different limits such taht error will arise
     **/
      const modifiedLimit = openPlacesModalFrom === 'serviceModal' ? limitForDay : limit;

      /**getPlaceThemes updates isLastPage variable and this function also updates the same variable.
      To ensure that first setLimtAndPage does not update after isLastPage is set true,
      this should be dispatched first11**/
      dispatch(
        setLimtAndPage({
          page: page + 1,
          limit: modifiedLimit,
          theme: themeType,
        })
      );

      // since arrays starts with 0
      const data = await dispatch(
        getPlaceThemes({
          placeId,
          theme: themeType,
          limit: modifiedLimit,
          page: page + 1,
          categories,
        })
      );
      if (data.length > 0) {
        dispatch(
          (function() {
            return { type: CHANGE_SLIDE, slideIndex: themeIdsArrayLength };
          })()
        );
      } else {
        dispatch(
          (function() {
            return { type: CHANGE_SLIDE, slideIndex: 0 };
          })()
        );
      }
    } else {
      dispatch(
        (function() {
          return { type: CHANGE_SLIDE, slideIndex: slideTo };
        })()
      );
    }
  };
};

export const changeSlideWithNoLoadMore = ({ slideTo, slideIndex }) => {
  return dispatch => {
    dispatch(
      (function() {
        return { type: CHANGE_SLIDE, slideIndex: slideTo };
      })()
    );
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/placesModalActions.js